import { createContext } from 'react';
import { UpdateRiskStatusList } from '@amzn/change-guardian-approval-service-type-script-client/clients/changeguardianapprovalservice';
import { OptionDefinition } from '@amzn/awsui-components-react/polaris/internal/components/option/interfaces';
import { allSelectOption, riskDefaultDisplayOption } from '../table-definitions/filter-menu';

export interface RisksContextProps {
  updateRisks: (status: string, selectedRisks: UpdateRiskStatusList) => void;
  riskStatusFilterValue: OptionDefinition;
  ruleFilterValue: OptionDefinition;
  resourceTypeFilterValue: OptionDefinition;
  riskDisplayControlValue: string;
  filterRisks: (
    statusValue: OptionDefinition,
    ruleValue: OptionDefinition,
    resourceTypeValue: OptionDefinition
  ) => void;
  filterRiskStatus: (option: OptionDefinition) => void;
  filterRule: (option: OptionDefinition) => void;
  filterResourceType: (option: OptionDefinition) => void;
  updateRiskDisplay: (value: string) => void;
  resetAllRiskFilters: () => void;
}

/* eslint-disable @typescript-eslint/no-empty-function */
export const RisksContext = createContext<RisksContextProps>({
  updateRisks: () => {},
  resetAllRiskFilters: () => {},
  riskStatusFilterValue: allSelectOption,
  ruleFilterValue: allSelectOption,
  resourceTypeFilterValue: allSelectOption,
  riskDisplayControlValue: riskDefaultDisplayOption.id,
  filterRisks: () => {},
  filterRiskStatus: () => {},
  filterRule: () => {},
  filterResourceType: () => {},
  updateRiskDisplay: () => {}
});
